import React, { useState } from "react";
import { Dialog, DialogContent } from "./ui/dialog";
import { Button } from "./ui/button";
import { ScrollArea } from "./ui/scroll-area";
import { Input } from "./ui/input";

interface MessageModalProps {
  open: boolean;
  onClose: () => void;
  clientName: string;
}

const MessageModal: React.FC<MessageModalProps> = ({
  open,
  onClose,
  clientName,
}) => {
  const [messages, setMessages] = useState([
    { from: "client", text: "Hello! I need some help." },
    { from: "you", text: "Sure, how can I assist you?" },
  ]);
  const [input, setInput] = useState("");

  const sendMessage = () => {
    if (!input.trim()) return;
    setMessages([...messages, { from: "you", text: input }]);
    setInput("");
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="fixed bottom-4 right-4 w-[350px] sm:w-[400px] h-[500px] flex flex-col bg-white border border-gray-300 shadow-xl rounded-lg">
        <div className="flex items-center justify-between p-3 border-b border-gray-200">
          <div className="font-semibold text-gray-800 text-sm">
            Chat with {clientName}
          </div>
          <Button
            variant="ghost"
            size="sm"
            onClick={onClose}
            className="text-gray-500 hover:text-black"
          >
            ✕
          </Button>
        </div>
        <ScrollArea className="flex-1 px-3 py-2 overflow-y-auto">
          {messages.map((msg, index) => (
            <div
              key={index}
              className={`mb-2 flex ${
                msg.from === "you" ? "justify-end" : "justify-start"
              }`}
            >
              <div
                className={`px-3 py-2 rounded-lg text-sm max-w-[70%] ${
                  msg.from === "you"
                    ? "bg-blue-600 text-white"
                    : "bg-gray-100 text-gray-900"
                }`}
              >
                {msg.text}
              </div>
            </div>
          ))}
        </ScrollArea>
        <div className="p-3 border-t border-gray-200 flex items-center gap-2">
          <Input
            type="text"
            placeholder="Type a message..."
            value={input}
            onChange={(e) => setInput(e.target.value)}
            className="flex-1"
            onKeyDown={(e) => e.key === "Enter" && sendMessage()}
          />
          <Button size="sm" onClick={sendMessage}>
            Send
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default MessageModal;
